import clsx from "clsx";
import React from "react";
import { Container, ContainerProps, Grid2 } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { useClient } from "../../hooks/useClient";

import { ClientSummary } from "./ClientSummary";
import { useNavigate } from "react-router-dom";
import { ProgressDialog } from "../client-progress/ProgressDialog";

import { ProfileCardPosition } from "../settings/coach-client-profile/utils";
import { ProfileCards } from "./ProfileCards";
import { TagDto } from "@growth-machine-llc/stridist-api-client";

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
    maxWidth: breakpoints.values.slg,
  },
}));

export enum ClientDetailsDialogMode {
  PROGRESS = "progress",
  STATS = "stats",
}

export interface ClientDetailsProps extends Omit<ContainerProps, "children"> {
  dialog?: ClientDetailsDialogMode;
  positions?: ProfileCardPosition[];
  isPreview?: boolean;
  tags?: TagDto[];
}

const ClientDetails = ({
  className,
  dialog,
  positions,
  isPreview,
}: ClientDetailsProps) => {
  const s = useStyles();
  const navigate = useNavigate();
  const client = useClient();

  return (
    <Container className={clsx(s.root, className)}>
      <Grid2 sx={{ mb: 3 }} container spacing={3} alignItems="stretch">
        <Grid2 size={12}>
          <ClientSummary client={client} />
        </Grid2>
        <ProfileCards
          client={client}
          profilePositions={positions}
          isPreview={isPreview}
        />
      </Grid2>
      <ProgressDialog
        open={dialog === ClientDetailsDialogMode.PROGRESS}
        onClose={() => navigate(-1)}
        clientId={client.id}
      />
    </Container>
  );
};

export default ClientDetails;
